module.exports = __webpack_public_path__ + "static/media/70.3d5f6180.png";